import DatesConversion from '@/mixins/DatesConversion';

export default {
  mixins: [DatesConversion],

  methods: {
    separateDayAndTime(slotToConvert) {
      const editedSlot = {
        id: slotToConvert.id,
      };
      const day = slotToConvert.start.toISOString().split('T')[0];
      editedSlot.day = day;

      const startTime = slotToConvert.start;
      let startHour = startTime.hour();
      if (startHour < 10) startHour = `0${startHour}`;
      let startMinutes = startTime.minute();
      if (startMinutes < 10) startMinutes = `0${startMinutes}`;

      const endTime = slotToConvert.end;
      let endHour = endTime.hour();
      if (endHour < 10) endHour = `0${endHour}`;
      let endMinutes = endTime.minute();
      if (endMinutes < 10) endMinutes = `0${endMinutes}`;

      editedSlot.start = `${startHour}:${startMinutes}`;
      editedSlot.end = `${endHour}:${endMinutes}`;

      return editedSlot;
    },

    convertSlotToBeDisplaied(slot) {
      const start = this.convertDateInChoosenTimezone(slot.start_date);
      const end = this.convertDateInChoosenTimezone(slot.end_date);

      let newSlot = {
        id: slot.id,
        start,
        end,
      };

      newSlot = this.separateDayAndTime(newSlot);

      return newSlot;
    },
  },
};
